export default {"src":"/_next/static/image/public/images/ic_share.79818b81fb9245cbbbb88c02e8070cdf.svg","height":20,"width":18};